// extracted by mini-css-extract-plugin
export default {"link":"IB-z","disabled":"JB-z"};